export const offersLink=[
    {
        id:1,
        Name:'GLOBAL MARKET',
        color:"#071945"
    },
    {
        id:2,
        Name:'BACK OFFICE',
        color:"#071945",
    },
    {
        id:3,
        Name:'TRADE ONLINE',
        color:"#EB0900"
    },
    {
        id:4,
        Name:'REFER & EARN',
        color:"#0057FF",
    },
    {
        id:5,
        Name:'OPEN AN ACCOUNT',
        color:"#183885"
    }

]